import initialState from './initialState';
import {
  FILTER_BY_SEARCH_TERM,
  FILTER_BY_SEARCH_TERM_DONE,
  FILTER_BY_SEARCH_TERM_ERROR,
  FILTER_BY_SEARCH_TERM_LOADING,
  FILTER_BY_SEARCH_TERM_SUCCESS
} from '../actions/actionTypes';

// Create your Reducer here...
const reducerFilterBySearchTerm = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_BY_SEARCH_TERM_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FILTER_BY_SEARCH_TERM_SUCCESS:
      return {
        ...state,
        error: null,
        filteredArray: action.filteredArray
      };
    case FILTER_BY_SEARCH_TERM_ERROR:
      return {
        ...state,
        error: action.error,
        filteredArray: null
      };
    case FILTER_BY_SEARCH_TERM_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(FILTER_BY_SEARCH_TERM)) {
    return reducerFilterBySearchTerm(state, action);
  } else {
    return state;
  }
};
